export default __webpack_public_path__ + "static/media/261.1ff84a5b.png";